import { getPbmBenefit, getWhatsappPbmBenefit, Medicine, PSPBenefit } from '../../interfaces/medicine';

export type PbmStep = 'consent' | 'success' | 'error';

/**
 * Visibility predicate for every PBM component (badge, in-edition checkbox,
 * sidebar entry point).
 */
export function shouldShowPbm(flag: boolean, beneficios?: PSPBenefit[]): boolean {
  return flag === true && getPbmBenefit(beneficios) !== undefined;
}

/**
 * Rescue predicate evaluated before prescription emission.
 */
export function shouldShowPbmRescue(flag: boolean, items?: Medicine[]): boolean {
  return (
    flag === true &&
    (items ?? []).some(
      (m) =>
        !!getPbmBenefit(m.Beneficios) &&
        m.pbmConsentGiven !== true &&
        m.pbmRescueDismissed !== true
    )
  );
}

/**
 * Visibility predicate for the WhatsApp PBM components (in-edition checkbox, card chip).
 */
export function shouldShowWhatsappPbm(flag: boolean, beneficios?: PSPBenefit[]): boolean {
  return flag === true && getWhatsappPbmBenefit(beneficios) !== undefined;
}

/**
 * Rescue predicate for the WhatsApp PBM, evaluated before prescription emission.
 *
 * The backend stores the consent per prescription, so a single consented item is enough to
 * skip the rescue for the whole prescription.
 */
export function shouldShowWhatsappPbmRescue(flag: boolean, items?: Medicine[]): boolean {
  if (flag !== true) return false;
  const eligible = (items ?? []).filter((m) => !!getWhatsappPbmBenefit(m.Beneficios));
  if (eligible.some((m) => m.pbmConsentGiven === true)) return false;
  return eligible.some((m) => m.pbmRescueDismissed !== true);
}

/**
 * Close-decision mapping for the consent sidebar.
 */
export function shouldShowCancelOnClose(step: PbmStep): boolean {
  return step === 'consent';
}

/**
 * Confirmation-action enablement for the consent step.
 */
export function isPbmConfirmDisabled(consentGiven: boolean, isLoading?: boolean): boolean {
  return consentGiven === false || !!isLoading;
}
